import * as Api from '@ViewModels';
import { useMemo, useState } from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';

interface UseFeatureCardParams {
	cardName: string;
	userRole?: Api.UserRole;
}

export const useFeatureCard = ({ cardName, userRole = 'user' }: UseFeatureCardParams) => {
	const userSession = useUserSession();

	const initialShowCard = useMemo(() => {
		let roleMatch = false;
		switch (userRole) {
			case 'superAdmin':
				roleMatch = userSession.userRole === 'superAdmin';
				break;
			case 'admin':
				roleMatch = userSession.userRole === 'admin' || userSession.userRole === 'superAdmin';
				break;
			case 'user':
				roleMatch =
					userSession.userRole === 'user' || userSession.userRole === 'admin' || userSession.userRole === 'superAdmin';
				break;
			case 'limitedUser':
				roleMatch = true;
				break;
			default:
				return false;
		}

		return !(window.localStorage.getItem(cardName) === 'true') && roleMatch;
	}, [cardName, userRole, userSession.userRole]);

	const [showCard, setShowCard] = useState(initialShowCard);

	const onClose = () => {
		window.localStorage.setItem(cardName, 'true');
		setShowCard(false);
	};

	return {
		showCard,
		onClose,
	};
};
